import Services from "@/components/Services";
import { motion } from "framer-motion";
import { BRAND } from "@/lib/constants";
import usePageTitle from "@/lib/usePageTitle";

export default function ServicesPage() {
  usePageTitle("Services");
  return (
    <>
      <section className="bg-white border-b border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end"
          >
            <div className="lg:col-span-8">
              <div className="font-mono text-[10px] uppercase tracking-widest-plus text-[#B08A4A] mb-4">
                Clinical Services · Full Directory
              </div>
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-[#0A2540]">
                Advanced diagnostics,
                <br />
                <span className="italic text-[#2E5AA5]">personally reviewed</span>.
              </h1>
            </div>
            <div className="lg:col-span-4">
              <p className="font-sans text-base text-[#475569] leading-relaxed">
                {BRAND.name} runs four core service lines. Every report is
                signed off by a Gold Medalist consultant pathologist.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
      <Services variant="full" />
    </>
  );
}
